import React, { useEffect, useState } from "react";
import { PrimaryButton } from "../styles/buttons";
import Popup, { PopupContent, PopupContentWithClose } from "../widgets/Popup";
import TouLogoSrc from "./imgs/logo-name.png";
import CaUniPoster1 from './imgs/ca_poster1.jpg';

export const TouStartPopup = React.memo<{
	onClose: () => void;
	onStart: () => void;
	secondaryText: string | JSX.Element;
}>(function TouStartPopup({ onStart, onClose, secondaryText }) {
	const [isDisabled, setIsdisabled] = useState(true);
	useEffect(() => {
		const timeout = setTimeout(() => {
			setIsdisabled(false);
		}, 3 * 1000);
		return () => {
			clearTimeout(timeout);
		};
	}, []);
	return (
		<Popup onClose={onClose}>
			<PopupContent
				style={{
					padding: 20,
					width: 600,
					maxWidth: "95%",
					fontFamily: "FiraGo",
					textAlign: "left",
					fontSize: 20,
				}}
				// className={styles.euroUniPopupContent}
			>
				<b>გახსოვდეს:</b>
				<br />
				<br />
				<b>შენ გარანტირებულად გახდები</b> თბილისის ღია უნივერსიტეტის
				სტუდენტი!
				<br />
				<br />
				<b>თუ</b> {secondaryText}
				<br />
				<br />
				<div style={{ textAlign: "center" }}>
					<PrimaryButton
						onClick={onStart}
						isFaded={isDisabled}
						disabled={isDisabled}
					>
						გამოცდის დაწყება
					</PrimaryButton>
				</div>
			</PopupContent>
		</Popup>
	);
});

export const TouDistractingPopup = React.memo<{ onClose: () => void }>(
	function TouDistractingPopup({ onClose }) {
		return (
			<Popup onClose={onClose}>
				<PopupContentWithClose
					style={{
						padding: "10px 0",
						width: 600,
						maxWidth: "95%",
						fontFamily: "FiraGo",
						textAlign: "center",
						fontSize: 19,
					}}
					onClose={onClose}
				>
					<div style={{ textAlign: "center", marginTop: 0 }}>
						<img
							src={TouLogoSrc}
							alt="eu logo"
							style={{ maxHeight: 90, maxWidth: "90%" }}
						/>
					</div>
					<br />
					<br />
					ალბათ ფიქრობ უადგილოა ეს წარწერა, მაგრამ ეროვნულის წერის
					დროსაც ბევრი უადგილო შეკითხვა დაისმება კლასში, არ შეიმჩნიო
					და ტესტზე კონცენტრირდი! <br />
					<br />
					😊 უთხარი შენს თავს : „დღეს შენი დღეა!“{" "}
				</PopupContentWithClose>
			</Popup>
		);
	}
);

export const HistInstructions = React.memo<{}>(function HistInstructions({}) {
	return (
		<span
			style={{ display: "block", textAlign: "left", marginBottom: -20 }}
		>
			ძვირფასო აბიტურიენტო,<br/><br/>
			იმიტირებულ გამოცდებს <b>ისტორიაში</b> Murtsku.com-ის პლატფორმაზე თქვენთვის აფინანსებს კავკასიის საერთაშორისო უნივერსიტეტი!<br/><br/>
			<b>ტესტის მიზანია თქვენი გამოცდასთან ადაპტაცია და დროის ეფექტური მართვის უნარის განვითარება.</b><br /><br/>
			ისტორიის ეროვნულ გამოცდაზე მაქსიმალური ქულა არის 60, თუმცა ჩვენს იმიტირებულ  გამოცდაზე ტესტი არ შეიცავს მიზეზ-შედეგობრიობის დავალებას ( 7 ქულა) შესაბამისად იმიტირებული გამოცდის მაქსიმალური ქულაა 53!<br /><br/>
			გამოცდა ჩაბარებულად ჩაგეთვლებათ თუ დააგროვებთ მაქსიმალური ქულის 25%-ზე მეტს.<br /><br/>
			მაქსიმალური დრო - 2 საათი<br /><br/>
			იმიტირებული ტესტირება დაგეხმარება გამოსცადო საკუთარი თავი საგამოცდო ფორმატში და თავდაჯერებული შეხვდე ერთიან ეროვნულ გამოცდებს! <br/>
			გამოცდის შედეგები კონფიდენციალურია და ხელმისაწვდომია მხოლოდ შენთვის!
			<br/><br/>
			<b>გისურვებთ წარმატებას !</b>
		</span>
	);
});

export const EngInstructions = React.memo<{}>(function EngInstructions({}) {
	return (
		<span
			style={{ display: "block", textAlign: "left", marginBottom: -20 }}
		>
			ძვირფასო აბიტურიენტო,<br/><br/>
			იმიტირებულ გამოცდებს <b>ინგლისურ ენაში</b> Murtsku.com-ის პლატფორმაზე თქვენთვის აფინანსებს კავკასიის საერთაშორისო უნივერსიტეტი!<br/><br/>
			<b>ტესტის მიზანია თქვენი გამოცდასთან ადაპტაცია და დროის ეფექტური მართვის უნარის განვითარება.</b><br /><br/>
			ინგლისური ენის იმიტირებული გამოცდის მაქსიმალური ქულა არის 54 ! ეროვნულ გამოცდაზე ინგლისური ენის გამოცდა 70 ქულიანია. იმიტირებულ გამოცდაზე ამოღებულია ესეს სავარჯიშო (16 ქულა) ამიტომ იმიტირებული გამოცდა 54 ქულიანია<br /><br/>
			გამოცდა ჩაბარებულად ჩაგეთვლებათ თუ დააგროვებთ მაქსიმალური ქულის 20%-ზე მეტს.<br /><br/>
			მაქსიმალური დრო - 2 საათი<br /><br/>
			იმიტირებული ტესტირება დაგეხმარება გამოსცადო საკუთარი თავი საგამოცდო ფორმატში და თავდაჯერებული შეხვდე ერთიან ეროვნულ გამოცდებს! <br/>
			გამოცდის შედეგები კონფიდენციალურია და ხელმისაწვდომია მხოლოდ შენთვის!
			<br/><br/>
			<b>გისურვებთ წარმატებას !</b>
		</span>
	);
});

export const MathInstructions = React.memo<{}>(function EngInstructions({}) {
	return (
		<span
			style={{ display: "block", textAlign: "left", marginBottom: -20 }}
		>
			შენ იწყებ ეროვნული გამოცდების მოდელირების წერას <b>მათემატიკაში,</b>{" "}
			რომლის მაქსიმალური ქულაა <b>43 ქულა</b> (ნაცვლად 51-სა), ხოლო{" "}
			<b>წერის დრო - 2,5 სთ</b> (ნაცვლად 3 სთ-სა).
			<br />
			<br />
			მოდელირება შედგენილია ეროვნული გამოცდების პროგრამის მიხედვით და
			მაქსიმალურად მიახლოებულია ეროვნული გამოცდის ფორმატთან - ტესტური და
			ღია სავარჯიშოების რაოდენობები ზუსტად ემთხვევა, თუმცა ვინაიდან 3 და 4
			ქულიან ამოცანებში დიდი მნიშვნელობა ენიჭება ამოცანის ამოხსნის გზას
			(რომელსაც ჩვენ ვერ ვამოწმებთ), 8-ვე ღია ტიპის სავარჯიშო იქნება 2
			ქულიანი.
			<br />
			<br />
			გაითვალისწინე, რომ{" "}
			<b>ნაშრომი გასწორდება ელექტონული პროგრამის მიერ,</b> ავტომატურად,
			ამიტომ მნიშვნელოვანია, რომ საკუთარი პასუხებში დააფიქსირო კონკრეტული
			პასუხი დამატებითი სიმბოლოების გარეშე.
			<br />
			<br />
			<b>მოდელირებაში ქულების ნაწილდება შემდეგნაირად:</b>
			<br />
			1 ქულიანი ტესტური (შემოსახაზი) სავარჯიშოები - 27 ტესტი - 27 ქულა
			<br />
			2 ქულიანი ღია ტიპის (ჩასაწერი) სავარჯიშოები - 8 სავარჯიშო - 16 ქულა
			<br />
			<br />
			<b>
				<u>შენი ჯამური შედეგის ნახვას შეძლებ წერის დასრულებისთანავე,</u>
			</b>{" "}
			ხოლო ნაშრომსა და სწორ პასუხებზე წვდომა გექნება{" "}
			<b>
				ხუთშაბათს, 8 ივლისს, 12:00-დან დღის ბოლომდე{" "}
				<u>ამავე გვერდზე.</u>
			</b>
			<br />
			<br />
			<b>ახლა კი, მოდელირებაზე კონცენტრირდი და გვაჩვენე რა შეგიძლია!</b>
			<br />
			<br />
			<b>აბა, შენ იცი, წარმატებები!</b>
		</span>
	);
});

export const CaUniBannerPopup = ({ onClose }: {onClose: () => void}) => {
	return (
		<Popup onClose={onClose}>
			<img src={CaUniPoster1} style={{ maxWidth: "100%", margin: 20 }} />
		</Popup>
	);
} 